"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Eccellenza() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const headline = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const body = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const sideLabel = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const imageReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const badge = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="4913" id="eccellenza-in-ginecologia-e-ostetricia" className="relative w-full min-h-screen bg-background overflow-hidden dark bg-background text-foreground">
      {}
      <div className="lg:hidden w-full h-[60vh] relative overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_consultation_mobile.webp" alt="Dott. Mirko Colloca durante una visita specialistica" loading="lazy" decoding="async" className="w-full h-full object-cover" src="https://drmirkocolloca.com/wp-content/uploads/2026/07/csi5nisvwaxak8yp9upg.webp" />
        <div className="absolute inset-0 bg-foreground/5 mix-blend-multiply pointer-events-none" />
        <div className="absolute bottom-6 left-6 w-20 h-20 rounded-lg bg-background/90 backdrop-blur-sm flex flex-col items-center justify-center border border-border">
          <span className="font-serif italic text-sm text-foreground">SPECIALISTA</span>
          <span className="font-mono text-[10px] tracking-widest text-muted-foreground mt-1">Ob-Gyn</span>
        </div>
      </div>

      {}
      <div className="relative w-full min-h-screen lg:min-h-screen flex flex-col lg:flex-row">
        {}
        <div className="relative w-full lg:w-[58%] min-h-[80vh] lg:min-h-screen flex flex-col justify-center px-6 sm:px-10 lg:px-16 xl:px-24 py-16 lg:py-0">
          {}
          <div ref={eyebrow.ref} className={`transition-all duration-1000 ease-out ${eyebrow.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.25em] text-muted-foreground">&nbsp;ECCELLENZA MEDICA</p>
            <div className="mt-4 w-12 h-px bg-foreground/30" />
          </div>

          {}
          <h1 ref={headline.ref} className={`font-default font-light text-foreground mt-8 lg:mt-10 leading-[0.95] transition-all duration-1000 delay-150 ease-out ${headline.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          letterSpacing: "-0.03em"
        }}>
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[9rem]">
              Dott. Mirko
            </span>
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[9rem] italic font-normal" style={{
            color: "var(--primary)"
          }}>
              Colloca
            </span>
            <span className="block !text-5xl">Medico Chirugo</span>
          </h1>

          {}
          <p ref={body.ref} className={`font-default mt-10 lg:mt-14 max-w-[380px] text-foreground/75 text-base sm:text-lg leading-relaxed transition-all duration-1000 delay-300 ease-out ${body.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            Specialista in Ginecologia e Ostetricia, esperto in Fisiopatologia della Riproduzione Umana e Ginecologia Forense. Dedizione, competenza e rigore scientifico al servizio della salute femminile.
          </p>

          {}
          <div ref={ctas.ref} className={`mt-10 lg:mt-12 flex flex-col sm:flex-row gap-4 transition-all duration-1000 delay-500 ease-out ${ctas.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <Button asChild size="lg" className="rounded-lg px-8 py-6 text-base font-default tracking-wide shadow-md bg-primary text-primary-foreground">
              <Link to="/ContactsPage">Prenota una Visita</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-lg px-8 py-6 text-base font-default tracking-wide border-foreground/30 bg-transparent text-foreground hover:bg-foreground/5">
              <Link to="/ProfilePage">Il Mio Profilo</Link>
            </Button>
          </div>

          {}
          
        </div>

        {}
        <div ref={imageReveal.ref} className={`hidden lg:block relative w-[42%] min-h-screen overflow-hidden transition-all duration-1500 ease-out ${imageReveal.isVisible ? "opacity-100" : "opacity-0"}`}>
          <div className="absolute inset-0 w-full h-[110%]" style={{
          transform: `translateY(${scrollY * 0.15}px)`
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_professional_portrait.webp" alt="Ritratto professionale del Dott. Mirko Colloca" loading="lazy" decoding="async" className="w-full h-full object-cover" src="https://robust-glider.10web.cloud/wp-content/uploads/2026/07/images.jpeg" />
            {}
            <div className="absolute inset-0 mix-blend-overlay opacity-30 pointer-events-none" style={{
            backgroundImage: "radial-gradient(hsla(22, 14%, 22%, 0.15) 1px, transparent 1px)",
            backgroundSize: "3px 3px"
          }} />
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-foreground/10 pointer-events-none" />
          </div>

          {}
          <div ref={badge.ref} className={`absolute bottom-16 left-8 xl:left-12 z-10 w-28 h-28 xl:w-32 xl:h-32 rounded-lg bg-background/95 backdrop-blur-sm border border-border flex flex-col items-center justify-center shadow-md transition-all duration-1000 delay-700 ease-out ${badge.isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
            <span className="font-serif italic text-lg xl:text-xl text-foreground">Dr. M. C.&nbsp;</span>
            <div className="w-8 h-px bg-foreground/40 my-2" />
            <span className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground">
              MEDICO
            </span>
          </div>
        </div>
      </div>

      {}
      <div className="hidden lg:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 z-20">
        <div className="relative w-px h-16 bg-foreground/20 overflow-hidden">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-lg" style={{
          backgroundColor: "var(--secondary)",
          animation: "scrollDot 2s ease-in-out infinite"
        }} />
        </div>
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          Scroll
        </span>
      </div>

      <style>{`
        @keyframes scrollDot {
          0% { transform: translate(-50%, -100%); opacity: 0; }
          20% { opacity: 1; }
          80% { opacity: 1; }
          100% { transform: translate(-50%, 6400%); opacity: 0; }
        }
      `}</style>
    </section>;
}